/**
 * @name: confirmPay 支付确认页面
 * @description：
 * @author: king
 * @time：2022-10-10 11:23:29
 *
 */
// 通用顶部条组件
const topbar = () =>import ("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_Nav = () =>import ("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () =>import ("../../layout/AppHeader_main");
// 通用底部组件
const AppFooter = () =>import ("../../layout/AppFooter");
// 当前路由组件
const confirmPay = () => import('../../views/confirmPay/pay.vue');
const confirmPayForcpeos = () => import('../../views/confirmPay/payForcpeos.vue');
export default [{
  path: "/confirmPay",
  name: "confirmPay",
  components: {
    topbar:topbar,
    header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: confirmPay,
    footer: AppFooter,
  },
  meta: {
    requireAuth: true // 需要验证登录状态
  },
  props: {
    header: {
      type:'1',//根据不同类型切入组件判断逻辑
    }
  },
},{
  path: "/confirmPayForcpeos",
  name: "confirmPayForcpeos",
  components: {
    topbar:topbar,
    header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: confirmPayForcpeos,
    footer: AppFooter,
  },
  meta: {
    requireAuth: true // 需要验证登录状态
  },
  props: {
    header: {
      type:'1',//根据不同类型切入组件判断逻辑
    }
  },
},
]
